import { NotificationItem } from '../../client/notificationsClient';

/**
 * Sample notifications for /design galleries (design reference only — the
 * live bell always renders real `GET /trp/notifications` rows). Times are
 * relative so the "2h ago" labels stay truthful whenever the page is opened.
 */
const minutesAgo = (minutes: number): string => new Date(Date.now() - minutes * 60_000).toISOString();

export const sampleNotifications: NotificationItem[] = [
  {
    id: 'design-n1',
    type: 'SUPPLIER_REPLY',
    title: 'Nova Motion Works replied',
    body: 'New reply on Hub motor, brushless DC',
    rfqId: 'RFQ-042',
    rfqName: 'Gripper actuator refresh',
    threadId: 'thread-nova-1',
    componentId: 'COMP-1',
    componentName: 'Hub motor, brushless DC',
    supplierName: 'Nova Motion Works',
    createdAt: minutesAgo(2 * 60),
  },
  {
    id: 'design-n2',
    type: 'SUPPLIER_REPLY',
    title: 'Oriental Motor replied',
    body: 'New reply on Stepper motor NEMA-17',
    rfqId: 'RFQ-042',
    rfqName: 'Gripper actuator refresh',
    threadId: 'thread-oriental-1',
    componentId: 'COMP-2',
    componentName: 'Stepper motor NEMA-17',
    supplierName: 'Oriental Motor',
    createdAt: minutesAgo(5 * 60),
  },
  {
    id: 'design-n3',
    type: 'SUPPLIER_REPLY',
    title: 'RCDrone replied',
    body: 'New reply on RC Drone Kit',
    rfqId: 'RFQ-039',
    rfqName: 'Drone build',
    threadId: 'thread-rcdrone-1',
    componentId: 'COMP-3',
    componentName: 'RC Drone Kit',
    supplierName: 'RCDrone',
    readAt: minutesAgo(20 * 60),
    createdAt: minutesAgo(26 * 60),
  },
];

export const sampleUnreadCount = sampleNotifications.filter((n) => !n.readAt).length;
